<template>
  <router-link to="/login">
    <div class="btn btn-outline disabled">
      <span class=" select-none">Login</span>
    </div>
  </router-link>
</template>

<script>
export default {

}
</script>

<style lang="postcss">

</style>
